/**
 * @generated SignedSource<<8d9a8d02111b3b37b527087c03cf427e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dataHealthPage_SourceWindowMutation$variables = {
  declaredFrom?: any | null | undefined;
  declaredTo?: any | null | undefined;
  reason?: string | null | undefined;
  sourceKey: string;
};
export type dataHealthPage_SourceWindowMutation$data = {
  readonly sourceWindowSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly sourceWindow: {
      readonly key: string;
    } | null | undefined;
  } | null | undefined;
};
export type dataHealthPage_SourceWindowMutation = {
  response: dataHealthPage_SourceWindowMutation$data;
  variables: dataHealthPage_SourceWindowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "declaredFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "declaredTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceKey"
},
v4 = [
  {
    "kind": "Variable",
    "name": "declaredFrom",
    "variableName": "declaredFrom"
  },
  {
    "kind": "Variable",
    "name": "declaredTo",
    "variableName": "declaredTo"
  },
  {
    "kind": "Variable",
    "name": "reason",
    "variableName": "reason"
  },
  {
    "kind": "Variable",
    "name": "sourceKey",
    "variableName": "sourceKey"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHealthPage_SourceWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SourceWindowSetMutationPayload",
        "kind": "LinkedField",
        "name": "sourceWindowSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceWindow",
            "kind": "LinkedField",
            "name": "sourceWindow",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataHealthPage_SourceWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SourceWindowSetMutationPayload",
        "kind": "LinkedField",
        "name": "sourceWindowSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceWindow",
            "kind": "LinkedField",
            "name": "sourceWindow",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae235a2e51164c58cf2ab43c01c3b6ba",
    "id": null,
    "metadata": {},
    "name": "dataHealthPage_SourceWindowMutation",
    "operationKind": "mutation",
    "text": "mutation dataHealthPage_SourceWindowMutation(\n  $sourceKey: String!\n  $declaredFrom: ISO8601Date\n  $declaredTo: ISO8601Date\n  $reason: String\n) {\n  sourceWindowSet(sourceKey: $sourceKey, declaredFrom: $declaredFrom, declaredTo: $declaredTo, reason: $reason) {\n    sourceWindow {\n      key\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "623edf2b5a535500f9d2fcccad0943a5";

export default node;
